/// <amd-module name="Test/ManageTestPlans/Components/HubErrorBar" />
import { MessageBar, MessageBarSeverity } from "VSSUI/MessageBar";
import * as React from "react";
import { TestPlanDirectoryActionsHub } from "Test/ManageTestPlans/Actions/TestPlanDirectoryActionsHub";
import { IHubErrorMessageState } from "Test/ManageTestPlans/Contracts";
import { IVssComponentProperties, VssComponent } from "VSS/Platform/Layout";


export class HubErrorBar extends VssComponent<IVssComponentProperties, IHubErrorMessageState> {

    constructor(props: IVssComponentProperties) {
        super(props);
        this._actionsHub = TestPlanDirectoryActionsHub.getInstance();

        this.state = {};
    }

    private _actionsHub: TestPlanDirectoryActionsHub;

    public render(): JSX.Element {
        if (!this.state.errorMessage) {
            return null as any;
        }

        return <div className="testplan-directory-messagebar" >
            <MessageBar
                severity={MessageBarSeverity.Error}
                onDismiss={() => { this.setState({ errorMessage: "" }); }}>
                {this.state.errorMessage}
            </MessageBar>
        </div>;
    }

    public componentDidMount() {
        this._actionsHub.showErrorMessage.addListener(this._onErrorMessageChanged);
    }

    public componentWillUnmount(): void {
        // Remove listener
        this._actionsHub.showErrorMessage.removeListener(this._onErrorMessageChanged);
    }

    /**
     * Update state when store is updated
     */
    private _onErrorMessageChanged = (error: Error): void  => { 
        this.setState({
            errorMessage: error.message
        });
    }
}